module.exports = __webpack_public_path__ + "img/HQ-PS24-V1_ALL.dfddc92c.jpg";